import { apiUrl } from '../constantsSMB/apiUrl'
import api from '../serviceSMB/apiService'
import { Utils } from '../utilSMB/utils'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../serviceSMB/logService';
import { errorAction } from './errorAction'
import { getVZDLInit } from '../serviceSMB/vzdl'

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

export const addShippingInfo = (dispatch) => {
    dispatch({ type: 'SHIPPINGINFOSTATUS', value: "completed" });
    dispatch({ type: 'BILLINGINFOSTATUS', value: "incomplete" });
}

export const updateSignInProfileInfo = (dispatch) => {
    dispatch({ type: 'SHIPPINGINFOSTATUS', value: "completed" });
    dispatch({ type: 'BILLINGINFOSTATUS', value: "completed" });
}

export const addBillingInfo = (dispatch) => {
    dispatch({ type: 'BILLINGINFOSTATUS', value: "completed" });
}

export const editShippingInfo = (dispatch) => {
    dispatch({ type: 'SHIPPINGINFOSTATUS', value: "incomplete" });
}

export const updateShippingInfoStatus = (dispatch, data) => {
    dispatch({ type: 'UPDATESHIPPINGINFOSTATUS', value: data });
}

export const updateExpressCheckout = (dispatch, data) => {
    dispatch({ type: 'UPDATEEXPRESSCHECKOUT', value: data });
}

export const updateBillingInfoStatus = (dispatch, data) => {
    dispatch({ type: 'UPDATEBILLINGINFOSTATUS', value: data });
}

export const udpateBillingSection = (dispatch, data) => {
    dispatch({ type: 'UPDATEBILLINGSECTION', value: data });
}

export const updateChangeAddressInfo = (dispatch, data) => {
    dispatch({ type: 'UPDATECHANGEADDRESSSTATUS', value: data });
}

export const editBillingInfo = (dispatch) => {
    dispatch({ type: 'BILLINGINFOSTATUS', value: "incomplete" });
}

export const addPersonalInfo = (dispatch, personalInfo) => {
    dispatch({ type: 'ADDPERSONALINFO', value: personalInfo });
}

export const updateBillingInfo = (dispatch, billingInfo) => {
    dispatch({ type: 'ADDBILLINGINFO', value: billingInfo });
}

export const updateOTPAttempts = (dispatch, noOfOTPAttemps) => {
    dispatch({ type: 'UPDATEOTPATTEMPTS', value: noOfOTPAttemps });
}
export const updatePlzceOrderAttemps = (dispatch, noOfPlzceOrderAttemps) => {
    dispatch({ type: 'UPDATEPLACEORDERATTEMPTS', value: noOfPlzceOrderAttemps });
}

export const updateThreeDSCounter = (dispatch, threeDSCounter) => {
    dispatch({ type: 'UPDATETHREEDSCOUNTER', value: threeDSCounter });
}
export const updateSafeTechCounter = (dispatch, safeTechCounter) => {
    dispatch({ type: 'UPDATESAFETECHCOUNTER', value: safeTechCounter });
}

export const updateBillingAddressStatus = (dispatch, isValidBillingAddress) => {
    dispatch({ type: 'UPDATEBILINGADDRESSSTATUS', value: isValidBillingAddress });
}

export const udpatePaymentStatus = (dispatch, isValidCard) => {
    dispatch({ type: 'UPDATEPAYMENTSTATUS', value: isValidCard });
}

export const updateThreeDSEMVError = (dispatch, showTDSError) => {
    dispatch({ type: 'UPDATETHREEDSEMVERROR', value: showTDSError });
}

export const updateProfileInfo = (dispatch, profileInfo) => {
    //var response = require('../containers/checkout/profile.json');
    dispatch({ type: 'UPDATEPROFILEINFO', value: profileInfo });
}

export const updateSignInStatus = (dispatch, profileInfo) => {
    dispatch({ type: 'UPDATESIGNINSTATUS', value: profileInfo });
}

export const updatePartialSignIn = (dispatch, isPartialSignIn) => {
    dispatch({ type: 'UPDATEPARTIALSIGNIN', value: isPartialSignIn });
}

export const editPartialSignIn = (dispatch, isEditPartialSignIn) => {
    dispatch({ type: 'EDITPARTIALSIGNIN', value: isEditPartialSignIn });
}

export const nonExpressCheckoutStatus = (dispatch, status) => {
    dispatch({ type: 'NONEXPRESSCHECKOUTSTATUS', value: status });
}

export const showBtaOption = (dispatch, status) => {
    dispatch({ type: 'SHOWBTAOPTION', value: status });
}

export const updateCustomerAction = (dispatch, couponInfo) => {
    dispatch({ type: 'UPDATECUSTOMERACTION', value: couponInfo });
}

export const addCouponInfo = (dispatch, couponInfo) => {
    dispatch({ type: 'ADDCOUPONINFO', value: couponInfo });
}

export const showPlaceOrder = (dispatch, showBtn) => {
    dispatch({ type: 'SHOWPLACEORDER', value: showBtn });
}

export const showPlaceOrderErrorMsg = (dispatch, showErrorBtn) => {
    dispatch({ type: 'SHOWPLACEORDERERRORMSG', value: showErrorBtn });
}
export const showMaxAttemptsErrorMsg = (dispatch, showError) => {
    dispatch({ type: 'SHOWMAXATTEMPTSERRORMSG', value: showError });
}

export const showThreeDSMaxAttemptsErrorMsg = (dispatch, showError) => {
    dispatch({ type: 'SHOWTHREEDSMAXATTEMPTSERRORMSG', value: showError });
}

export const showVepsMaxAttemptsErrorMsg = (dispatch, showError) => {
    dispatch({ type: 'SHOWVEPSMAXATTEMPTSERRORMSG', value: showError });
}

export const showLecOnlyErrorMsg = (dispatch, showError) => {
    dispatch({ type: 'SHOWLECONLYERRORMSG', value: showError });
}
export const showPOErrorMsg = (dispatch, showError) => {
    dispatch({ type: 'SHOWPOERRORMSG', value: showError });
}
export const getCheckoutContentFromApi = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('checkoutpage', visitId, 'checkoutpage', "checkout page"))
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        const checkoutPageContent = apiUrl().checkoutPageContent
        return new Promise((resolve, reject) => {
            api(checkoutPageContent, 'GET').then(response => {

                window.scrollTo(0, 0);
                dispatch({ type: 'CHECKOUTCONTENTFROMAPI', value: response })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                resolve(response);
            }).catch(error => {
                let errorMsg = `MethodName:checkoutpage,errorMessage:${error.message}`;
                logKafka("ERROR", "checkoutpage", errorMsg, getErrorLogUrl, "applogs", visitId);
                getVZDLInit(visitId,"","","","","","",error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
        })
    } catch (ex) {
        catchJSException('FaqPage', visitId, 'faq', ex);
    }
}
export const getShippingMethod = (dispatch, shippingOption, visitId, request) => {
    // export const getShippingMethod = (dispatch, shippingOption,visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getCategoriesFromAPI', "Inside getCategoriesFromAPI"));
        let url = apiUrl().shipping;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        api(url, 'POST', request).then(response => {
            if (Utils.isNotNull(response) && Utils.isNotNull(response.shippingItemList) && response.shippingItemList.length > 0) {
                shippingOption.options = response.shippingItemList;
                shippingOption.selectedProd = shippingOption.selectedProd === "" ? response.shippingItemList[0].shippingId : shippingOption.selectedProd;
                dispatch({ type: 'SHIPPINGMETHOD', value: shippingOption });
                // dispatch({ type: 'SHIPPINGMETHOD', value: response.shippingItemList });
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:getCategoriesFromAPI,errorMessage:${error.message}`;
                logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
                getVZDLInit(visitId,"","","","","","",error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getCategoriesFromAPI', ex);
    }
}

export const updateShippingMethod = (dispatch, shippingOption, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getCategoriesFromAPI', "Inside getCategoriesFromAPI"));
        dispatch({ type: 'SHIPPINGMETHOD', value: shippingOption });
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getCategoriesFromAPI', ex);
    }
}

export const monInvoked = (status, dispatch) => {
    dispatch({ type: 'MONINVOKEDFROMAPI', value: status })
};

export const getMonFromApi = (dispatch, visitId, stateFromLq, isGetMonFailed = false, cookies = null) => {
    try {
        logOtherInfo(detailsInfo('CheckoutPage', visitId, 'getMonFromApi', "Inside getMonFromApi"));
        let url = apiUrl().getMonUrl;
        if (Utils.isNotEmpty(stateFromLq))
            url = apiUrl().getMonUrl + "?serviceState=" + stateFromLq
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        api(url, 'GET', '').then(response => {
            if (Utils.isNotNull(response) && Utils.isNotNull(response.meta) && response.meta.code === 200.01) {
                if (cookies) {
                    cookies.set('mon', response.data.mon);
                }
                dispatch({ type: 'MONFROMAPI', value: response.data });
                monInvoked(true, dispatch);

            }
            else if (!isGetMonFailed) {
                getMonFromApi(dispatch, visitId, stateFromLq, true, cookies);
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

        })
            .catch(error => {
                let errorMsg = `MethodName:getMonFromApi,errorMessage:${error.message}`;
                logKafka("ERROR", "CheckoutPage", errorMsg, getErrorLogUrl, "applogs", visitId);
                getVZDLInit(visitId,"","","","","","",error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

            });
    } catch (ex) {
        catchJSException('CheckoutPage', visitId, 'getMonFromApi', ex);
    }

}
export const getTaxFromApi = (request, dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('CheckoutPage', visitId, 'getTaxFromApi', "Inside getTaxFromApi"));
        let url = apiUrl().getTaxUrl;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        api(url, 'POST', request).then(response => {
            if (Utils.isNotNull(response) && response.data.taxAmount !== "") {
                let taxAmount = parseFloat((response.data.taxAmount)).toFixed(2)
                dispatch({ type: 'TAXFROMAPI', value: taxAmount });
                getCart(visitId, dispatch);
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }
        ).catch(error => {
            let errorMsg = `MethodName:getTaxFromApi,errorMessage:${error.message}`;
            logKafka("ERROR", "CheckoutPage", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });

        })
    } catch (ex) {
        catchJSException('CheckoutPage', visitId, 'getTaxFromApi', ex);
    }

}
export const placeYourOrder = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('CheckoutPage', visitId, 'placeYourOrder', "Inside placeYourOrder"));
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        const orderSubmitUrl = apiUrl().orderSubmit+"?vtp=Y";
        return new Promise((resolve, reject) => {
            api(orderSubmitUrl, 'GET', '').then(response => {
                resolve(response);
                dispatch({ type: 'PLACEORDER', value: true });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                // accessoriesAction.getCategoriesFromAPI(this.props.dispatch,response)
            }).catch(error => {
                let errorMsg = `MethodName:placeYourOrder,errorMessage:${error.message}`;
                logKafka("ERROR", "CheckoutPage", errorMsg, getErrorLogUrl, "applogs", visitId);
                getVZDLInit(visitId,"","","","","","",error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
        })

    } catch (ex) {
        catchJSException('CheckoutPage', visitId, 'placeYourOrder', ex);
    }
}
export const jwtToken = (request, visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('CheckoutPage', visitId, 'jwtToken', "Inside jwtToken"));
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        const jwtTokenUrl = apiUrl().jwtToken;
        return new Promise((resolve, reject) => {
            api(jwtTokenUrl, 'POST', request).then(response => {
                resolve(response);
                dispatch({ type: 'JWTTOKEN', value: response.data });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                // accessoriesAction.getCategoriesFromAPI(this.props.dispatch,response)
            }).catch(error => {
                let errorMsg = `MethodName:jwtToken,errorMessage:${error.message}`;
                logKafka("ERROR", "CheckoutPage", errorMsg, getErrorLogUrl, "applogs", visitId);
                getVZDLInit(visitId,"","","","","","",error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
        })

    } catch (ex) {
        catchJSException('CheckoutPage', visitId, 'jwtToken', ex);
    }
}
export const vepsLookup = (request, visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('CheckoutPage', visitId, 'vepsLookup', "Inside vepsLookup"));
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        const vepsLookupUrl = apiUrl().vepsLookup;
        return new Promise((resolve, reject) => {
            api(vepsLookupUrl, 'POST', request).then(response => {
                dispatch({ type: 'VEPSRESPONSE', value: response.data });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                resolve(response);
            }).catch(error => {
                let errorMsg = `MethodName:vepsLookup,errorMessage:${error.message}`;
                logKafka("ERROR", "CheckoutPage", errorMsg, getErrorLogUrl, "applogs", visitId);
                getVZDLInit(visitId,"","","","","","",error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
        })
    } catch (ex) {
        catchJSException('CheckoutPage', visitId, 'vepsLookup', ex);
    }
}

export const getCart = (visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('CheckoutPage', visitId, 'getCart', "Inside getCart"));
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        let getCart = apiUrl().getCart + visitId + "?accessoryType=vtp";
        let shippingCharge = "0.00";
        return new Promise((resolve, reject) => {
            api(getCart, 'GET', '').then(response => {
                //dispatch({ type: 'GETCARTRESPONSE', value: response.data});
                if (response.data.shippingCharge !== "" && response.data.shippingCharge === 0) {
                    shippingCharge = "0.00";
                } else {
                    shippingCharge = response.data.shippingCharge;
                }
                dispatch({ type: 'CARTPRODUCTSDETAILSFROMJSON', value: response.data.prodAccessoryList, subTotal: response.data.subTotal, total: response.data.total, shippingcrg: shippingCharge, shippingDiscount: response.data.shippingDiscountPrice, tax: response.data.tax });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                resolve(response);
            }).catch(error => {
                let errorMsg = `MethodName:getCart,errorMessage:${error.message}`;
                logKafka("ERROR", "CheckoutPage", errorMsg, getErrorLogUrl, "applogs", visitId);
                getVZDLInit(visitId,"","","","","","",error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
        })
    } catch (ex) {
        catchJSException('CheckoutPage', visitId, 'getCart', ex);
    }
}

export const updateIntent = (request, visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('CheckoutPage', visitId, 'updateIntent', "Inside updateIntent"));
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        let updateIntent = apiUrl().updateIntent + '/' + visitId;
        let shippingCharge = "0.00";
      
        return new Promise((resolve, reject) => {
            api(updateIntent, 'POST', request).then(response => {
                if (response.data.shippingCharge !== "" && response.data.shippingCharge === 0) {
                    shippingCharge = "0.00";
                } else {
                    shippingCharge = response.data.shippingCharge;
                }
                dispatch({ type: 'CARTPRODUCTSDETAILSFROMJSON', value: response.data.prodAccessoryList, subTotal: response.data.subTotal, total: response.data.total, shippingcrg: shippingCharge, shippingDiscount: response.data.shippingDiscountPrice, tax: response.data.tax });            
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                resolve(response);
            }).catch(error => {
                let errorMsg = `MethodName:updateIntent,errorMessage:${error.message}`;
                logKafka("ERROR", "CheckoutPage", errorMsg, getErrorLogUrl, "applogs", visitId);
                getVZDLInit(visitId,"","","","","","",error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
        })
    } catch (ex) {
        catchJSException('CheckoutPage', visitId, 'updateIntent', ex);
    }
}

export const updateCoupon = (request, visitId, dispatch) => {
    try {
        logOtherInfo(detailsInfo('CheckoutPage', visitId, 'updateCoupon', "Inside updateCoupon"));
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        let updateCoupon = apiUrl().updateIntent + '/' + visitId;
        let shippingCharge = "0.00";
        let couponInfo = {
            couponCode: '',
            couponError: ''
        }
        return new Promise((resolve, reject) => {
            api(updateCoupon, 'POST', request).then(response => {
                if (response.data.shippingCharge !== "" && response.data.shippingCharge === 0) {
                    shippingCharge = "0.00";
                } else {
                    shippingCharge = response.data.shippingCharge;
                }
                if (response.data.couponResponse === "VALID") {
                    couponInfo = {
                        couponError: 'VALID'
                    }
                    addCouponInfo(dispatch, couponInfo);
                } else {
                    couponInfo = {
                        couponCode: '',
                        couponError: "That discount isn't recognized",
                    }
                    addCouponInfo(dispatch, couponInfo);
                }
                dispatch({ type: 'CARTPRODUCTSDETAILSFROMJSON', value: response.data.prodAccessoryList, subTotal: response.data.subTotal, total: response.data.total, shippingcrg: shippingCharge, shippingDiscount: response.data.shippingDiscountPrice, tax: response.data.tax });
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                resolve(response);
            }).catch(error => {
                let errorMsg = `MethodName:updateCoupon,errorMessage:${error.message}`;
                logKafka("ERROR", "CheckoutPage", errorMsg, getErrorLogUrl, "applogs", visitId);
                getVZDLInit(visitId,"","","","","","",error.message);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            })
        })
    } catch (ex) {
        catchJSException('CheckoutPage', visitId, 'updateCoupon', ex);
    }
}
// export const getProfileInfo = (dispatch, visitId) => {
//     try {
//         let url = apiUrl().profileInfo;
//         let isProfileCallSuccess = false;
//         dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
//         return new Promise((resolve, reject) => {
//         api(url, 'GET', '').then(response => {
//             if (response !== null && response.data !== null && response.data !== "" && response.data.profileResponse !== undefined && response.data.profileResponse !== null && response.data.profileResponse !== "" ) {
//                 dispatch({ type: 'PROFILECALL', value: true });
//                 if (response.data.profileResponse.billingAddress !== "" && response.data.profileResponse.billingAddress.addressline1 !== "" && response.data.profileResponse.billingAddress.city !== ""
//                     && response.data.profileResponse.billingAddress.state !== "" && response.data.profileResponse.billingAddress.zip !== "") {
//                     dispatch({ type: 'VALIDUSER', value: true });

//                     dispatch({ type: 'UPDATEPROFILEINFO', value: response.data });
//                     isProfileCallSuccess=true;
//                     // if (response.data.profileResponse && response.data.profileResponse.customerContact && response.data.profileResponse.billingAddress && response.data.profileResponse.customerContact.firstName !== "" && response.data.profileResponse.customerContact.lastName !== "" && response.data.profileResponse.customerContact.email !== "" && response.data.profileResponse.customerContact.mTN !== ""
//                     //     && response.data.profileResponse.billingAddress.addressline1 !== "" && response.data.profileResponse.billingAddress.city !== "" && response.data.profileResponse.billingAddress.state !== "" && response.data.profileResponse.billingAddress.zip !== ""
//                     //     && response.data.profileResponse.customerContact.firstName !== null && response.data.profileResponse.customerContact.lastName !== null && response.data.profileResponse.customerContact.email !== null && response.data.profileResponse.customerContact.mTN !== null
//                     //     && response.data.profileResponse.billingAddress.addressline1 !== null && response.data.profileResponse.billingAddress.city !== null && response.data.profileResponse.billingAddress.state !== null && response.data.profileResponse.billingAddress.zip !== null) {
//                     //     updateSignInStatus(dispatch, true);
//                     // }
//                     // else {
//                     //     updatePartialSignIn(dispatch, true);
//                     // }
//                 }
//                 if (response.data.profileResponse.fraudCustomer) {
//                     /** rendering dynamic error content for fraud customer */
//                     errorAction("FRAUD_ErrorMsg", "checkout", "checkout", "applogs", visitId, dispatch, true, "IssueInAccount");
//                 }
//             } else {
//                 dispatch({ type: 'ISGUESTFLOW', value: true });
//             }
//             dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
//             resolve(isProfileCallSuccess);
//         }).catch(error => {
//             console.log("error in profile pull ", error)
//             getVZDLInit(visitId,"","","","","","",error.message);
//         })
//     })
//     } catch (ex) {

//     }
// }   